import FilterListIcon from "@mui/icons-material/FilterList";
import { Button, Paper, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { PacakgeNameFilter } from "../../publicPackages2/filter/PacakgeNameFilter";

function clearURLSearchParams() {
  const url = new URL(window.location.href);
  url.search = "";
  window.history.pushState({}, "", url.toString());
}

export function FilterSideMenu({ children }: PropsWithChildren) {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid rgba(0,0,0,0.08)" }}>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          <FilterListIcon color="primary" />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
            }}
          >
            Filtry
          </Typography>
        </Stack>
        <Button size="small" color="inherit" sx={{ textTransform: "none" }} onClick={clearURLSearchParams}>
          Wyczyść
        </Button>
      </Stack>
      <PacakgeNameFilter paramName="name" />
      <Stack spacing={4}>{children}</Stack>
    </Paper>
  );
}
